import React, { useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import {compose} from '@bem-react/core';
import Filters from './Filters';
import VisTagsDevices from '../tab-bodies/Tags-Devices';
import BEMTabs from '../../../BemComponents/Tabs';
import FenceBody from '../tab-bodies/FenceBody/FenceBody';
import {iFullStoreState, ItemType} from '../../../shared/interfaces';
import {withTabsThemeDarkNew} from '../../../BemComponents/Tabs/_theme/Tabs_theme_dark_new';
import {withTabsStyledUnderlinedNew} from '../../../BemComponents/Tabs/_styled/Tabs_styled_underlined_new';
import { KmlModal } from '../../KmlModal';
import { KmlActions } from '../../../stores/reducers/kml-reducers';
import { watchKmlFiles } from '../../../shared/db/kml-db';

const LayersTabs = ({activeTab}): JSX.Element => {
    const dispatch = useDispatch()
    const hasShowedTags = useSelector<iFullStoreState, boolean>((state) => {
        return state.tagsDevicesMap.showedTagsIds.size > 0;
    });

    const item = {itemType: null, itemId: null};

    const Tabs = compose(withTabsThemeDarkNew, withTabsStyledUnderlinedNew)(BEMTabs);

    const hash = window.location.hash.split('/').filter((item) => item !== '#');
    const itemData = hash.reduce((acc, rec) => {
        if (rec === 'device' || rec === 'tag' || rec === 'person') {
            return {...acc, itemType: rec};
        }

        if (rec === 'tags') {
            return {...acc, itemType: rec, itemdId: null};
        }

        return {...acc, itemId: rec};
    }, {...item});

    useEffect(() => {
        dispatch(KmlActions.SET_MAP_VISIBILITY(true));

        const unsubscribeData = watchKmlFiles((files) => {
             dispatch(KmlActions.SET_FILES(files));
        });

        return () => {
            dispatch(KmlActions.SET_MAP_VISIBILITY(false));
            if (typeof unsubscribeData === 'function') unsubscribeData();
        }
    }, [dispatch]);

    // Build children array explicitly so Tabs always gets an array without undefined entries
    const childrenElements: React.ReactNode[] = [];

    // Fences tab always present
    childrenElements.push(
        <div key="fences" data-label="Fences">
            <FenceBody itemId={itemData.itemId} itemType={itemData.itemType as ItemType} />
        </div>
    );

    // KMl tab always present
    childrenElements.push(
        <div key="kml" data-label="KML">
            <KmlModal />
        </div>
    );

    if (itemData.itemType !== 'tags' && itemData.itemType !== 'device') {
        childrenElements.push(
            <div key="filters" data-label="Filters">
                <Filters />
            </div>
        );
        childrenElements.push(
            <div key="devices" data-label="Devices">
                <VisTagsDevices />
            </div>
        );
    }

    // Ensure no falsy entries (defensive)
    const finalChildren = childrenElements.filter(Boolean);

    return (
        <Tabs styled="underlined_new" theme="dark_new" activeTab={activeTab}>
            {finalChildren as React.ReactElement[]}
        </Tabs>
    );
};

export default LayersTabs;
